"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../../../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: ", "px;\n\tcursor: pointer;\n\tuser-select: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: 90px;\n\theight: 206px;\n\toverflow-y: scroll;\n\tborder: 1px solid ", ";\n\tpadding: 1px ", ";\n\n\t& ::-webkit-scrollbar-track {\n\t\tcolor: white;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0 0 ", " 0;\n\tfont-family: ", ";\n\ttext-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: 0 ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var buildValues = function buildValues(unit, increment, min, max) {
  var values = [];

  for (var i = min; i <= max; i += increment) {
    values.push(i);
  }

  return values;
};

var Container = _styledComponents.default.div(_templateObject(), _spacing.default.s3);

Container.displayName = 'Container';

var Heading = _styledComponents.default.h4(_templateObject2(), _spacing.default.s1, _vars.default.fontStackBold);

Heading.displayName = 'Heading';

var ListBox = _styledComponents.default.div(_templateObject3(), _colors.default.greyPale, _spacing.default.s1);

ListBox.displayName = 'ListBox';
var itemHeight = 40;

var ListBoxOption = _styledComponents.default.div(_templateObject4(), function (props) {
  return props.selected && "\n\t\tbackground-color: " + _colors.default.primary + ";\n\t\tcolor: " + _colors.default.white + ";\n\t\tborder-radius: " + _vars.default.borderRadius + ";\n\t";
}, itemHeight);

ListBoxOption.displayName = 'ListBoxOption';

var formatNumber = function formatNumber(v) {
  return v.toString().padStart(2, '0');
};

var UnitInput = function UnitInput(_ref) {
  var value = _ref.value,
      unit = _ref.unit,
      onChange = _ref.onChange,
      increment = _ref.increment,
      min = _ref.min,
      max = _ref.max;
  var listBoxRef = (0, _react.useRef)();
  var options = buildValues(unit, increment, min, max);
  (0, _react.useEffect)(function () {
    /* istanbul ignore next */
    if (listBoxRef && listBoxRef.current && listBoxRef.current.scrollTo) {
      // when opened, ensure the selected value is in the ListBox viewport
      var index = options.findIndex(function (option) {
        return option === value;
      });
      var scrollIndex = itemHeight * (index - 2);
      listBoxRef.current.scrollTo(0, scrollIndex);
    }
  }, []);
  var heading = unit === 'hours' ? 'Hour' : 'Minute';
  return _react.default.createElement(Container, null, _react.default.createElement(Heading, null, heading), _react.default.createElement(ListBox, {
    ref: listBoxRef,
    role: "listbox",
    "aria-label": heading
  }, options.map(function (opt) {
    return _react.default.createElement(ListBoxOption, {
      role: "option",
      selected: opt === value,
      "aria-selected": opt === value,
      onClick: function onClick() {
        return onChange(opt);
      },
      key: unit + "_" + opt
    }, formatNumber(opt));
  })));
};

UnitInput.propTypes = {
  value: _propTypes.number.isRequired,
  unit: (0, _propTypes.oneOf)(['days', 'hours', 'minutes', 'seconds']).isRequired,
  onChange: _propTypes.func.isRequired,
  increment: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),
  min: _propTypes.number.isRequired,
  max: _propTypes.number.isRequired
};
UnitInput.defaultProps = {
  increment: 1
};
var _default = UnitInput;
exports.default = _default;